import React from 'react';

function ContactCard({ contactCard = null }) {
    if (!contactCard) {
        return null;
    }
    return (
        <div className="min-w-[330px] min-h-[120px] flex flex-col justify-between border-[1px] mb-6 border-gray rounded-lg">
            <div className="flex items-center py-3">
                <div className="px-3">
                    {contactCard.avatar}
                </div>
                <div className="flex flex-col">
                    <p className="font-bold">{contactCard.name}</p>
                    <p className="text-[14px]">{contactCard.email}</p>
                    {contactCard.birthday && <p className="text-[14px]">{`Born: ${contactCard.birthday}`}</p>}
                </div>
            </div>
            <div className="bg-gray-100 py-3 flex items-center justify-center rounded-b-lg">
                <p className="text-[12px]">{`From account ${contactCard.emailFrom}`}</p>
            </div>
        </div>
    );
}

export default ContactCard;
